// @ts-check
import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const SubscriptionPlatform = {
  "UNLIMITED_ACCESS": "UNLIMITED_ACCESS",
  "APPLE_STORE": "APPLE_STORE",
  "GOOGLE_PLAY": "GOOGLE_PLAY"
};

const UnitsOfLength = {
  "METRIC": "METRIC",
  "STATUTE": "STATUTE"
};

const Gender = {
  "FEMALE": "FEMALE",
  "MALE": "MALE"
};

const RaceSport = {
  "RUN": "RUN",
  "SWIM": "SWIM",
  "RIDE": "RIDE",
  "MULTISPORT": "MULTISPORT",
  "TRANSITION": "TRANSITION"
};

const { Race, RaceTag, User, UserExtraData, UserSubscription, UserSettings, AvailableSubscription, AppRemoteConfig, ParentRace, Location, Address, Coordinates, Color } = initSchema(schema);

export {
  Race,
  RaceTag,
  User,
  UserExtraData,
  UserSubscription,
  UserSettings,
  AvailableSubscription,
  AppRemoteConfig,
  SubscriptionPlatform,
  UnitsOfLength,
  Gender,
  RaceSport,
  ParentRace,
  Location,
  Address,
  Coordinates,
  Color
};